import BaseApiService from './BaseApiService';

class SmartAlertService extends BaseApiService {
  async previewAlerts(orgId) {
    return this.makeRequest(`/api/smart-alerts/admin/${orgId}/preview`, {
      method: 'GET',
    });
  }

  async dispatchAlerts(orgId) {
    return this.makeRequest(`/api/smart-alerts/admin/${orgId}/dispatch`, {
      method: 'POST',
    });
  }
}

const smartAlertService = new SmartAlertService();
export default smartAlertService;
